const Projects = {

    init() {
        this.el = $('[page="home"] [block="projects"]');
        if (!this.el.length) return;

        this.slider = this.el.find('.slider');
        this.bind();
    },

    bind() {
        this.slider.addClass('owl-carousel');
        this.slider.owlCarousel({
            "loop": false,
            "autoWidth": false,
            "nav": true,
            "dots": true,
            "margin": 0,
            "stagePadding": 0,
            "items": 1,
            navText: [
                '<span aria-label="' + 'Previous' + '" icon="arrow_forward"></span>',
                '<span aria-label="' + 'Next' + '" icon="arrow_forward"></span>'
            ],
            //
            // "navContainer": true,
            // "navContainerClass": 'owl-nav',
        });
        $(".owl-carousel").each(function(index) {
            $(this).find('.owl-nav, .owl-dots').wrapAll("<div class='owl-controls' data-aos='fade-up' data-aos-delay='800'></div>");
        });
    }
}

export default Projects;